import React from 'react';
import { ArrowRight, BarChart3, LineChart, PieChart } from 'lucide-react';
import { IMAGES } from '../mock';

const BusinessGrowth = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1280px] mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <p className="eyebrow mb-3">BUSINESS GROWTH</p>
          <h2 className="section-title text-4xl md:text-5xl mb-6">Improve Performance and Efficiency</h2>
          <p className="text-[#556a85] text-[16px] leading-relaxed mb-8">
            We help organizations optimize operations, streamline processes, and drive measurable results
            through data-driven strategies and modern tooling.
          </p>
          <div className="grid sm:grid-cols-3 gap-4 mb-8">
            {[
              { icon: BarChart3, label: 'Growth', v: '+120%' },
              { icon: LineChart, label: 'Efficiency', v: '85%' },
              { icon: PieChart, label: 'ROI', v: '4.2x' },
            ].map((s, i) => (
              <div key={i} className="bg-[#f6f9fc] rounded-xl p-4 border border-[#eef1f5]">
                <s.icon className="text-[#0a6cb0] mb-2" size={22} />
                <p className="text-2xl font-bold text-[#0a2c4d] font-serif-display">{s.v}</p>
                <p className="text-xs uppercase tracking-wider text-[#556a85]">{s.label}</p>
              </div>
            ))}
          </div>
          <a href="#services" className="pill-btn pill-btn-outline">
            EXPLORE SOLUTION <ArrowRight size={18} />
          </a>
        </div>
        <div className="order-first lg:order-last">
          <img src={IMAGES.growth} alt="Business growth" className="w-full h-[460px] object-cover rounded-2xl shadow-xl" />
        </div>
      </div>
    </section>
  );
};

export default BusinessGrowth;
